const HEART_BREAK_TIME = 50000
let g_websocket = null;
let g_interval = null;
let g_url, g_onmessage, g_uptime;

function onerror() {
    console.log('websocket error.')
}

function onclose(event) {
    console.log('websocket close, code = %s', event.code)
}

function onopen() {
    console.log('websocket open.')
}

function onmessage(event) {
    
    g_uptime = new Date().getTime();
    
    if (event.data == 'PONG') return
    g_onmessage(event)
}

function openWebSocket() {
    g_websocket = new WebSocket(g_url)
    g_websocket.onerror = onerror
    g_websocket.onopen = onopen
    g_websocket.onclose = onclose
    g_websocket.onmessage = onmessage
    g_uptime = new Date().getTime()
}


function oninterval() {
    
    if (!g_websocket) {
        openWebsocket()
    } else {
        const before_time = new Date().getTime() - HEART_BREAK_TIME - 3000
   
        if (g_uptime < before_time) {
            g_websocket.close()
            g_websocket = null
            openWebsocket()
        } else {
  
            g_websocket.send('PING')
        }
    }
}

function connect(url, onmessage) {
    g_url = url
    g_onmessage = onmessage
    g_interval = setInterval(oninterval, HEART_BREAK_TIME)
    openWebSocket()
}

function disconnect() {
    if (g_interval) {
        clearInterval(g_interval)
        g_interval = null
    }
    if (g_websocket) {
        g_websocket.close()
        g_websocket = null
    }
}

export default {
    connect,
    disconnect
}



// WEBPACK FOOTER //
// ./src/utils/ws.js